import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'thema-core-contact-expert',
  templateUrl: './contact-expert.component.html',
  styleUrls: ['./contact-expert.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContactExpertComponent {}
